const Video = (el) => {
    el.addEventListener('click', (e) => {
        const trigger = e.target;
        trigger.classList.remove('js-video-preview');
        trigger.querySelector('img').remove();
    });
};

export default Video;
